"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NotificationSDK", {
  enumerable: true,
  get: function get() {
    return _NotificationSDK.default;
  }
});
Object.defineProperty(exports, "getAllNotifications", {
  enumerable: true,
  get: function get() {
    return _NotificationSDK.getAllNotifications;
  }
});
Object.defineProperty(exports, "getAnnouncement", {
  enumerable: true,
  get: function get() {
    return _NotificationSDK.getAnnouncement;
  }
});
Object.defineProperty(exports, "getNotificationById", {
  enumerable: true,
  get: function get() {
    return _NotificationSDK.getNotificationById;
  }
});
Object.defineProperty(exports, "getUnreadNotifcations", {
  enumerable: true,
  get: function get() {
    return _NotificationSDK.getUnreadNotifcations;
  }
});
Object.defineProperty(exports, "markNotificationAsRemoveById", {
  enumerable: true,
  get: function get() {
    return _NotificationSDK.markNotificationAsRemoveById;
  }
});
Object.defineProperty(exports, "notificationReducer", {
  enumerable: true,
  get: function get() {
    return _notification.notificationReducer;
  }
});

var _NotificationSDK = _interopRequireWildcard(require("./NotificationSDK"));

var _notification = require("./reducer/notification");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }